import React, { useState, StrictMode } from 'react';

import useMembers from 'components/Common/Managers/Hooks/useMembers';
import Header from './Widgets/Header';
import Statistics from './Widgets/Statistics/Index';
import TalentIndex from './Widgets/TalentIndex/Index';

export default function Index() {
  const members = useMembers();

  const [filteredMembers, setFilteredMembers] = useState(null);

  const onFilteredDataChange = (data) => {
    setFilteredMembers(data);
  };

  return (
    <StrictMode>
      <div className="content">
        <Header />
        <Statistics members={filteredMembers} />
      </div>

      <div className="content">
        <section>
          <TalentIndex members={members} onFilteredDataChange={onFilteredDataChange} />
        </section>
      </div>

    </StrictMode>
  );
}
